<template>
    <div>
        <v-container>
            <v-layout row wrap>
                <v-flex x12 sm12>
                    Filters:
                    <v-btn @click="filterReset()">All Activity</v-btn>
                    <v-btn @click="filterFeed('New Client')">New Client Added</v-btn>
                    <v-btn @click="filterFeed('Onboarding Complete')">Client Launched</v-btn>
                    <br>
                    Onboarding:
                    <v-btn @click="filterFeed('Onboarding Comment')">Comments</v-btn>
                    <v-btn @click="filterFeed('Onboarding Task Created')">Tasks Created</v-btn>
                    <v-btn @click="filterFeed('Onboarding Task Completed')">Tasks Completed</v-btn>
                    <v-btn @click="filterFeed('Onboarding Task Failed')">Tasks Failed</v-btn>
                    <br>
                    Management:
                    <v-btn @click="filterFeed('Management Comment')">Comments</v-btn>
                    <v-btn @click="filterFeed('Management Task Created')">Tasks Created</v-btn>
                    <v-btn @click="filterFeed('Management Task Completed')">Tasks Completed</v-btn>
                    <v-btn @click="filterFeed('Management Task Failed')">Tasks Failed</v-btn>
                    <hr style="margin-top: 20px;">
                    <v-timeline>
                            <v-slide-x-transition group>
                                <v-timeline-item v-for="(note, index) in notes" :key="index" class="font-weight-light" :icon="note.icon" :color="note.color" fill-dot large>
                                    <span slot="opposite"> 
                                        {{ note.authorFirstName }} 
                                        <br>
                                        <small> 
                                            {{ note.type }} 
                                            <br> 
                                            {{ note.time2 }}
                                        </small>
                                    </span>
                                    <v-card color="#212121" dark>
                                        <v-card-title :class="{ 'justify-end': note.even }" @click="viewClient(note)" style="font-size: 18px; font-weight: 400">
                                            {{ note.company }} 
                                        </v-card-title>
                                        <v-card-text style="background-color: #424242;">
                                            <v-layout>
                                                <v-flex :class="{ textRight: note.even }">
                                                    {{ note.text }}
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                    </v-card>
                                </v-timeline-item>
                            </v-slide-x-transition>
                    </v-timeline>
                    <v-btn v-if="notes.length > 0 && notes.length % 20 === 0  " @click="loadMore" color="dark" block>Load more...</v-btn>
                    <v-btn v-if="notes.length == 0" disabled @click="loadMore" color="dark" block>No data for this filter...</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import db from '../firebase/init.js'
import moment from 'moment'
export default {
    name: 'ActivityHistory',
    data(){
        return {
            commentInput: null,
            notes: [],
            loader: 20,
            evenTick: true,
            filter: 'Onboarding Comment',
            filterWatch: false,
            unsubscribe: null,
            clientData: {}
        }
    },
    methods: {
        loadMore(){
            this.loader = this.loader + 20
            if(this.filterWatch == false){
                this.loadFeed()
            }else{
                this.loadFeedFiltered()
            }
        },
        filterFeed(type){
            this.filter = type
            this.filterWatch = true
            this.loader = 20
            this.unsubscribe()
            this.loadFeedFiltered()
        },
        filterReset(){
            this.filterWatch = false
            this.loader = 20
            this.loadFeed()
        },
        viewClient(note){
            firebase.firestore().collection('clients').doc(note.companyID).get()
            .then(doc => {
                this.clientData = doc.data()
                this.$store.dispatch('setCurrentClient', this.clientData)
            }).then(() => {
                this.$router.push('/account-view/' + note.companyID)
            })
            .catch(err => { console.log('Error getting document', err) })
        },
        loadFeed(){
            this.evenTick = true
            this.unsubscribe = firebase.firestore().collection('activity').orderBy('time', 'desc').limit(this.loader).onSnapshot(snapshot => {
                this.notes = []
                snapshot.forEach(doc => {
                    let note = doc.data()
                    note.keyed = doc.id
                    if(note.type == 'Onboarding Comment'){
                        note.color = 'red darken-2'
                        note.icon = 'mode_comment'
                        note.stage = 'Onboarding'
                    }else if(note.type == 'Onboarding Task Created'){
                        note.icon = 'check_box_outline_blank'
                        note.color = 'red darken-2'
                        note.stage = 'Onboarding'
                    }else if(note.type == 'Onboarding Task Completed'){
                        note.icon = 'check_box'
                        note.color = 'red darken-2'
                        note.stage = 'Onboarding'
                    }else if(note.type == 'Onboarding Task Failed'){
                        note.icon = 'clear'
                        note.color = 'red darken-2'
                        note.stage = 'Onboarding'
                    }else if(note.type == 'Onboarding Failed'){
                        note.icon = 'clear'
                        note.color = 'red darken-2'
                        note.stage = 'Onboarding'
                    }else if(note.type == 'Onboarding Happiness Changed'){
                        note.icon = 'favorite'
                        note.color = 'red darken-2'
                        note.stage = 'Onboarding'
                    }else if(note.type == 'Management Comment'){
                        note.color = 'light-blue darken-3'
                        note.icon = 'mode_comment'
                        note.stage = 'Management'
                    }else if(note.type == 'Management Task Created'){
                        note.icon = 'check_box_outline_blank'
                        note.color = 'light-blue darken-3'
                        note.stage = 'Management'
                    }else if(note.type == 'Management Task Completed'){
                        note.icon = 'check_box'
                        note.color = 'light-blue darken-3'
                        note.stage = 'Management'
                    }else if(note.type == 'Management Task Failed'){
                        note.icon = 'clear'
                        note.color = 'light-blue darken-3'
                        note.stage = 'Management'
                    }else if(note.type == 'Management Happiness Changed'){
                        note.icon = 'favorite'
                        note.color = 'light-blue darken-3'
                        note.stage = 'Onboarding'
                    }else if(note.type == 'New Client'){
                        note.icon = 'stars'
                        note.color = 'yellow accent-4'
                        note.viewNumber = 0
                        note.type == 'New Client Added'
                    }else if(note.type == 'Onboarding Complete'){
                        note.icon = 'verified_user'
                        note.color = 'green darken-1'
                        note.stage = 'Management'
                        note.type == 'Client Onboarding Complete'
                    }else{
                        note.icon = 'person'
                        note.color = 'indigo'
                    }
                    note.even = this.evenTick
                    this.evenTick = !this.evenTick
                    note.time2 = moment(Number(note.time)).format('llll')
                    this.notes.push(note)
                })
            })
        },
        loadFeedFiltered(){
            this.evenTick = true
            firebase.firestore().collection('activity').where('type', '==', this.filter).orderBy('time', 'desc').limit(this.loader).onSnapshot(snapshot => {
                this.notes = []
                snapshot.forEach(doc => {
                    let note = doc.data()
                    note.keyed = doc.id
                    if(note.type == 'Onboarding Comment'){
                        note.color = 'red darken-2'
                        note.icon = 'mode_comment'
                        note.viewNumber = 0
                    }else if(note.type == 'Onboarding Task Created'){
                        note.icon = 'check_box_outline_blank'
                        note.color = 'red darken-2'
                        note.viewNumber = 0
                    }else if(note.type == 'Onboarding Task Completed'){
                        note.icon = 'check_box'
                        note.color = 'red darken-2'
                        note.viewNumber = 0
                    }else if(note.type == 'Onboarding Task Failed'){
                        note.icon = 'clear'
                        note.color = 'red darken-2'
                        note.viewNumber = 0
                    }else if(note.type == 'Management Comment'){
                        note.color = 'light-blue darken-3'
                        note.icon = 'mode_comment'
                        note.viewNumber = 2
                    }else if(note.type == 'Management Task Created'){
                        note.icon = 'check_box_outline_blank'
                        note.color = 'light-blue darken-3'
                        note.viewNumber = 2
                    }else if(note.type == 'Management Task Completed'){
                        note.icon = 'check_box'
                        note.color = 'light-blue darken-3'
                        note.viewNumber = 2
                    }else if(note.type == 'Management Task Failed'){
                        note.icon = 'clear'
                        note.color = 'light-blue darken-3'
                        note.viewNumber = 2
                    }else if(note.type == 'New Client'){
                        note.icon = 'stars'
                        note.color = 'yellow accent-4'
                        note.viewNumber = 2
                        note.type == 'New Client Added'
                    }else if(note.type == 'Onboarding Complete'){
                        note.icon = 'verified_user'
                        note.color = 'green darken-1'
                        note.viewNumber = 2
                        note.type == 'Client Onboarding Complete'
                    }else{
                        note.icon = 'person'
                        note.color = 'indigo'
                    }
                    note.even = this.evenTick
                    this.evenTick = !this.evenTick
                    note.time2 = moment(Number(note.time)).format('llll')
                    this.notes.push(note)
                })
            })
        }
    },
    mounted(){
        this.loadFeed()
        document.title = "Vaboo Activity History"
    }
}
</script>
<style>
.commentsList{
    max-height: 500px;
    overflow: scroll;
}
.textRight{
    text-align: right;
}
</style>